import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "book-unit book-unit--highlights" }
const _hoisted_2 = { class: "book-unit__highlights-text" }
const _hoisted_3 = { class: "book-unit__text book-unit__text--highlights" }
const _hoisted_4 = { class: "book-unit__text-c card-text" }
const _hoisted_5 = { class: "card-text__name" }
const _hoisted_6 = { class: "card-text__author card-text__author--no-margin" }
const _hoisted_7 = { class: "book-unit__bottom-box--highlights" }
const _hoisted_8 = {
  key: 0,
  class: "book-unit__highlights-link"
}
const _hoisted_9 = { class: "book-unit__highlights-messages" }
const _hoisted_10 = {
  key: 1,
  class: "book-unit__highlights-link"
}
const _hoisted_11 = { class: "book-unit__highlights-messages" }
const _hoisted_12 = {
  key: 2,
  class: "book-unit__highlights-link"
}
const _hoisted_13 = { class: "book-unit__highlights-messages" }

import { HighlightsAllDoc } from '@/models/interfaces'

import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightsCard',
  props: {
    book: {}
  },
  emits: ["unitClick"],
  setup(__props: any) {





function getNotesWord(notes: number): string {
  return notes === 1 ? `Note` : `Notes`
}

function getHighlightsWord(highlights: number): string {
  return highlights === 1 ? `Highlight` : `Highlights`
}

function getBookmarksWord(bookmarks: number): string {
  return bookmarks === 1 ? `Bookmark` : `Bookmarks`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "book-unit__link-box book-unit__link-box--highlights",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unitClick')))
    }, [
      _createVNode(BookCardThumbnail, {
        class: "book-unit__img list-c",
        coverClass: "list-card",
        fallbackCoverClass: "list-card",
        doc: __props.book
      }, null, 8, ["doc"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unitClick')))
              }, _toDisplayString(__props.book.title), 1)
            ]),
            _createElementVNode("h4", _hoisted_6, " By " + _toDisplayString(__props.book.author), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (__props.book.highlights_count)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "highlights__icon iconfont ihighlights" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(__props.book.highlights_count), 1),
                _createElementVNode("i", _hoisted_9, _toDisplayString(getHighlightsWord(__props.book.highlights_count)), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.book.notes_count)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "highlights__icon iconfont inotes" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(__props.book.notes_count), 1),
                _createElementVNode("i", _hoisted_11, _toDisplayString(getNotesWord(__props.book.notes_count)), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.book.bookmarks_count)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "highlights__icon iconfont iflag" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(__props.book.bookmarks_count), 1),
                _createElementVNode("i", _hoisted_13, _toDisplayString(getBookmarksWord(__props.book.bookmarks_count)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})